module.exports = __webpack_public_path__ + "static/media/21.b304d408.jpg";